//Imports React y librerías
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from 'react-router-dom';
//Imports contexts
import { AppContext } from "../../../contexts/AppContext";
import { AuthContext } from "../../../contexts/AuthContext";
//Imports Components
import MessageConfirmation from "../../messageConfirmation/MessageConfirmation";
//Imports Icon
import add from '../../../assets/icons/add.svg';
import view from '../../../assets/icons/visible.svg';
import editIcon from '../../../assets/icons/edit.svg';
// import deleteIcon from '../../../assets/icons/delete.svg';
import search from '../../../assets/icons/search.svg';
//Imports CSS
import './addProject.css'

function AddProject() {
    const { dataProjects, isLoading, establishmentList } = useContext(AppContext);
    const { userData } = useContext(AuthContext);
    const [searchItem, setSearchItem] = useState('');
    const [filteredProjects, setFilteredProjects] = useState(null);
    const [projectAddedSuccess, setProjectAddedSuccess] = useState(false);
    // Funciones auxiliares para determinar permisos
    const isAdmin = userData?.permissions === 'admin';
    const isSostenedor = userData?.dimension === 'Sostenedor';
    const isEstablishment = userData?.dimension === 'Establecimiento';

    const canAddProject = isAdmin;
    const canEditProject = isAdmin || isSostenedor;
    const canDeleteProject = isAdmin;

    useEffect(() => {
        // Verificar sessionStorage al montar el componente
        const projectAdded = sessionStorage.getItem('projectAdded');
        
        if (projectAdded === 'true') {
            // Transferir el valor de sessionStorage al estado de React
            setProjectAddedSuccess(true);
            
            // Eliminar de sessionStorage ya que ahora lo tenemos en el estado
            sessionStorage.removeItem('projectAdded');
        }
    }, []);

    useEffect(() => {
        // Solo crear el temporizador si projectAddedSuccess es true
        if (projectAddedSuccess) {
            // Crear temporizador para establecer el valor en false después de 3 segundos
            const timer = setTimeout(() => {
                setProjectAddedSuccess(false);
            }, 3000);
            
            // Función de limpieza que se ejecuta si el componente se desmonta
            return () => {
                clearTimeout(timer);
            };
        }
    }, [projectAddedSuccess]);

    const countEstablishmentsForProject = (projectId) => {
        return establishmentList.filter(establishment => establishment.projectId === projectId).length;
    };

    const handleSearchChange = (e) => {
        setSearchItem(e.target.value);
    }
    const filterProjects = () => {
        let filtered = dataProjects;

        if (isSostenedor || isEstablishment) {
            filtered = filtered.filter(project => project.id === userData.tenantId);
        }

        if (searchItem) {
            filtered = filtered.filter(project =>
                project.nameProject.toLowerCase().includes(searchItem.toLowerCase()) ||
                String(project.code).toLowerCase().includes(searchItem.toLowerCase())
            );
        }

        // Ordenar proyectos primero por región y luego por comuna (alfabéticamente)
        filtered = [...filtered].sort((a, b) => {
            // Primero ordenar por región
            const regionCompare = (a.region || '').localeCompare(b.region || '');
            
            // Si las regiones son iguales, ordenar por comuna
            if (regionCompare === 0) {
                return (a.commune || '').localeCompare(b.commune || '');
            }
            
            return regionCompare;
        });


        return filtered;
    };

    useEffect(() => {
        if (dataProjects && userData) {
            setFilteredProjects(filterProjects());
        }
    }, [dataProjects, userData, searchItem, isSostenedor, isEstablishment, isAdmin]);

    return (
        <>
            <section className='container-add-project'>
                <article className='box-search-project flex'>
                    <div className='box-input flex' >
                        <img src={search} className='icon-search' alt='Icono para buscar proyecto por nombre' />
                        <input type='text' name='searchProject' placeholder='Buscar por nombre o código' className='input-search' value={searchItem} onChange={handleSearchChange} />
                    </div>
                    {canAddProject && (
                        <Link to='/proyectos/agregar' state={{test: true}} className='add-project-button flex'>
                            <img src={add} className='icon' alt='Icono de agregar nuevo proyecto' />
                            <p>Agregar Nuevo Proyecto</p>
                        </Link>
                    )}
                </article>
                <table className='box-result-projects' >
                    <thead className='header-table' >
                        <tr>
                            <th>Código</th>
                            <th>Sostenedor</th>
                            <th>Región</th>
                            <th>Comuna</th>
                            <th>Establecimientos</th>
                            <th>Ver</th>
                            {canEditProject && <th>Editar</th>}
                            {/* {canDeleteProject && <th>Eliminar</th>} */}
                        </tr>
                    </thead>
                    <tbody className='body-table'>
                        {!isLoading && filteredProjects?.length == 0
                            ? (
                                <tr>
                                    <td colSpan='8'>No existen proyectos</td>
                                </tr>
                            ) : (filteredProjects?.map((project) => (
                                <tr key={project.id}>
                                    <td data-label='Código' className='td-code'>{project.code}</td>
                                    <td data-label='Sostenedor'>{project.nameProject}</td>
                                    <td data-label='Región'>{project.region}</td>
                                    <td data-label='Comuna'>{project.commune}</td>
                                    <td data-label='Establecimientos'>{countEstablishmentsForProject(project.id)}</td>
                                    <td data-label='Ver'>
                                        <Link to={`${project.id}`}>
                                            <img src={view} className='icon' alt='Icono para ver proyecto' />
                                        </Link>
                                    </td>
                                    {canEditProject && (
                                        <td data-label='Editar'>
                                            <Link to={`editar/${project.id}`}>
                                                <img src={editIcon} className='icon' alt='Icono para editar proyecto' />
                                            </Link>
                                        </td>
                                    )}
                                    {/* {canDeleteProject && (
                                        <td>
                                            <img src={deleteIcon} className='icon' alt='Icono para eliminar proyecto' />
                                        </td>
                                    )} */}
                                </tr>
                            ))
                            )}
                    </tbody>
                </table>
                <MessageConfirmation confirmation={projectAddedSuccess} error={false} view={true}/>
            </section>
        </>
    )
};

export default AddProject;